import { z } from 'zod';

import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';
import { creditsResponseSchema, type CreditsResponse } from '@/schemas/credit';

export const getCreditsParamsSchema = z.object({
  schoolId: z.number().optional(),
});

export type GetCreditsParams = z.infer<typeof getCreditsParamsSchema>;

export const getCredits = httpGetAdapter<CreditsResponse, GetCreditsParams>({
  url: (params) => `/v2/escolas/${params.schoolId}/credito`,
  schema: creditsResponseSchema,
});
